import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const AppStoreImg = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "app-store.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  if (!data?.placeholderImage?.childImageSharp?.fluid) {
    return null
  }

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      className="sm:w-44 w-32"
    />
  )
}

export default AppStoreImg
